const fieldErrorMapping = {
    EMPTY: {
        defaultValue: 'Required'
    },
    TOO_SHORT: {
        defaultValue: 'Too short',
        password: 'Password too short'
    },
    INVALID_VALUE: {
        defaultValue: 'Invalid value',
        email: 'Invalid email'
    },
    NOT_ENOUGH_FUNDS: {
        defaultValue: 'Not enough funds',
        currencyExchangeAmount: 'Sorry, you do not have sufficient balance in your wallet. Choose different wallet'
    },
    NOT_UNIQUE: {
        defaultValue: 'Not unique',
        email: 'An account is already registered with such email. Please log in or use another email to register.'
    },
    NOT_ACCEPTED: {
        defaultValue: 'Not accepted'
    },
    INVALID_CODE: {
        defaultValue: 'Invalid code'
    },
    PASSWORDS_NOT_EQUAL: {
        defaultValue: 'Passwords are not equal'
    },
    CAPITAL_CALL_EXCEEDS_TOTAL_INVESTMENTS: {
        defaultValue: 'Capital call exceeds total funded investments',
        email: 'Invalid email'
    },
    NO_SPLIT_IN_DEBENTURE_AMOUNT: {
        defaultValue: 'Amount cannot be split in debenture amounts',
        email: 'Invalid email'
    },
}
export const errorMapping = {
    GLOBAL: 'Oops, something went wrong. Please try again',
    INVALID_LOGIN: 'Invalid username or password'
}
export default {

    methods: {
        $fieldError (field, errorCode) {
            if (fieldErrorMapping[errorCode]) {
                return fieldErrorMapping[errorCode][field] || fieldErrorMapping[errorCode].defaultValue
            } else {
                return fieldErrorMapping.EMPTY.defaultValue
            }
        },
    }
}
